import React from 'react'
import ModalIcone from '../../components/ModalIcone'
import { JSONTree } from 'react-json-tree'
import { isBoolean } from 'underscore'
import helper from '../../utils/helper'
import ReactLoading from 'react-loading'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import ReferenciaParametrizacao from './referencia'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import GenericInputFormula from '../../components/GenericInputFormula/GenericInputFormula'
import ModalAvisoTimestampBuffer from '../../components/ModalAvisoTimestampBuffer'
import tourManager from '../../tours'
import demoSession from '../../tours/demo/DemoSession'
export default class Form extends React.Component {
    formulaRef = React.createRef()
    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

    state = {
        data: null,
        campoParametrizado: {
            descricao: '', identificador: '', formula: '', unidade: '', decimal: '2', operador_especial: 'padrao',
            tipo_dado_saida: 'decimal', tipo_grafico: 'linha', prioridade: '1', icone_on: null, icone_off: null,
            mascara: 'padrao',
        },
        validacao_campo: {
            descricao: true, identificador: true, formula: true, decimal: true,
            operador_especial: true, tipo_dado_saida: true, tipo_grafico: true, prioridade: true
        },
        teste: { resultado: '0', invalido: false, erro: '', status: false },
        iconModal: false,
        icone_tipo: "",
        cooldown: true,
        loading: false,
        tab: 0,
        modalReferencia: false,
        detalhesRefencia: {},
        referencias: [],
        isVirtual: false,
        parametros: [],
        loading_parametros: false,
        formula_template: "",
        parametros_in_formula: [],
        carregandoDados: false,

        formulaOnFocus: false,
        modalAvisoBuffer: false,
        modalConfirmarSemBuffer: false,
        salvandoBufferAviso: false,
        bufferAvisoDispensado: false,
    }

    clearForm = () => {
        this.setState({
            validacao_campo: {
                descricao: true, identificador: true, formula: true, decimal: true,
                operador_especial: true, tipo_dado_saida: true, tipo_grafico: true, prioridade: true
            },
            campoParametrizado: {
                descricao: '', identificador: '', formula: '', unidade: '', decimal: '2', operador_especial: 'padrao',
                tipo_dado_saida: 'decimal', tipo_grafico: 'linha', prioridade: '1', icone_on: null, icone_off: null,
                mascara: 'padrao',
            },
            teste: { resultado: '0', invalido: false, erro: '', status: false },
            iconModal: false,
            icone_tipo: "",
            cooldown: true,
            loading: false,
            tab: 0,
            detalhesRefencia: {},
            referencias: [],
            formula_template: "",
            parametros_in_formula: []
        })

        this.getParametros()
    }

    componentDidMount = async () => {
        const prefill = !this.props.match.params.id
            ? this.props.location?.state?.prefill
            : null

        if (prefill) {
            this.setState((prevState) => ({
                campoParametrizado: {
                    ...prevState.campoParametrizado,
                    descricao: prefill.descricao ?? "",
                    identificador: prefill.identificador ?? "",
                },
            }))
        }

        if (this.props.match.params?.imei) {
            this.buscarDados(this.props.match.params?.imei)
            this.getParametros()
            this.verificarAvisoBuffer()
        }

        if (this.props.match.params.id) {
            await axios({
                method: 'GET',
                url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/campo-customizado/${this.props.match.params.id}/`,
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
            }).then(res => {
                const { campoParametrizado } = this.state

                if (res.data.icone !== null) {
                    try {
                        let icone
                        if (typeof res.data?.icone == "string") {
                            icone = JSON.parse(res.data.icone)
                        } else {
                            icone = res.data?.icone
                        }

                        if (res.data.tipo_dado_saida === 'booleano') {
                            campoParametrizado['icone_on'] = icone?.icone_on
                            campoParametrizado['icone_off'] = icone?.icone_off
                        } else {
                            campoParametrizado['icone_on'] = icone?.icone_on
                        }
                    } catch (err) {
                        console.error(err)
                    }
                }

                campoParametrizado['formula'] = res.data.formula
                campoParametrizado['descricao'] = res.data.descricao
                campoParametrizado['identificador'] = res.data.identificacao
                campoParametrizado['unidade'] = res.data.unidade
                campoParametrizado['decimal'] = res.data.decimal
                campoParametrizado['mascara'] = res.data?.mascara ?? 'padrao'
                campoParametrizado['operador_especial'] = res.data.operador_especial
                campoParametrizado['prioridade'] = res.data.prioridade
                campoParametrizado['tipo_dado_saida'] = res.data.tipo_dado_saida
                campoParametrizado['tipo_grafico'] = res.data.tipo_grafico

                if (res.data.configuracao !== null) {
                    let configuracoes = JSON.parse(res.data.configuracao)
                    let formula_template = "formula_template" in configuracoes ? configuracoes.formula_template : res.data.formula 
                    let parametros_in_formula = "parametros_in_formula" in configuracoes ? configuracoes.parametros_in_formula : []

                    this.setState({ referencias: configuracoes.referencias, formula_template, parametros_in_formula })
                } else {
                    this.setState({ formula_template: res.data.formula })
                }

                this.setState({ campoParametrizado })

            }).catch(console.error)
        }
    }

    getParametros = () => {
        this.setState({ loading_parametros: true })

        const base = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}`
        const parametroId = this.props.match.params?.id

        axios.get(base + '/campo-customizado/?limit=100&equipamento=' + this.props.match.params.imei, this.configMe)
        .then((res) => {
            let parametros = res.data.results.map((parametro) => {
                let formula_template = ""

                if(parametro.configuracao !== null) {
                    let configuracoes = JSON.parse(parametro.configuracao)

                    formula_template = "formula_template" in configuracoes ? configuracoes.formula_template : parametro.formula 
                } else {
                    formula_template = parametro.formula
                }

                return {
                    descricao: parametro.descricao,
                    identificacao: parametro.identificacao,
                    formula: parametro.formula,
                    id: parametro.id,
                    formula_template
                }
            })

            if(parametroId) {
                parametros = parametros.filter((parametro) => parametro.id !== Number(parametroId))
            }

            this.setState({ parametros, loading_parametros: false })
        })
        .catch((error) => this.setState({ loading_parametros: false }))
    }

    buscarDados = async (equipamento) => {
        this.setState({ carregandoDados: true })

        await axios({
            method: 'GET',
            url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/equipamento/${equipamento}/historico/`,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(res => {
            if (res.data.modelo === 8) {
                this.setState({ isVirtual: true })
            }

            try {
                if (res.data?.last_report === false) return

                let campos = JSON.parse(res.data.last_report)
                this.setState({ data: campos })
            } catch (err) { }
        }).catch(console.error)

        this.setState({ carregandoDados: false })
    }

    veioDoCadastrarTimestamp = () =>
        this.props.location?.state?.prefill?.identificador === "timestamp_dispositivo"

    verificarAvisoBuffer = async () => {
        if (this.props.match.params.id || this.veioDoCadastrarTimestamp()) return
        if (tourManager.isActive() || demoSession.isActive()) return

        const equipamentoId = this.props.match.params.imei
        const base = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}`

        try {
            const [equipamentoRes, parametrosRes, historicoRes] = await Promise.all([
                axios.get(`${base}/equipamento/${equipamentoId}/`, this.configMe),
                axios.get(`${base}/campo-customizado/?limit=100&equipamento=${equipamentoId}`, this.configMe),
                axios.get(`${base}/equipamento/${equipamentoId}/historico/`, this.configMe),
            ])

            const comunicou = historicoRes.data?.last_report !== "null" && historicoRes.data?.last_report != null
            const timestampCadastrado = parametrosRes.data?.results?.some(
                (parametro) => parametro.identificacao === "timestamp_dispositivo"
            )
            const bufferAvisoDispensado = equipamentoRes.data?.validacao?.buffer_aviso_dispensado === true

            if (tourManager.isActive() || demoSession.isActive()) return

            this.setState({
                bufferAvisoDispensado,
                modalAvisoBuffer: Boolean(comunicou && !timestampCadastrado && !bufferAvisoDispensado),
            })
        } catch (error) {
            console.error(error)
        }
    }

    cadastrarTimestampDispositivo = () => {
        this.setState((prevState) => ({
            modalAvisoBuffer: false,
            campoParametrizado: {
                ...prevState.campoParametrizado,
                descricao: "timestamp dispositivo",
                identificador: "timestamp_dispositivo",
            },
        }))
    }

    dispensarAvisoBuffer = () => {
        if (this.state.salvandoBufferAviso) return

        const equipamentoId = this.props.match.params.imei
        this.setState({ salvandoBufferAviso: true })

        axios.patch(
            `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/equipamento/${equipamentoId}/`,
            { buffer_aviso_dispensado: true },
            this.configMe
        ).then(() => {
            this.setState({
                bufferAvisoDispensado: true,
                modalAvisoBuffer: false,
                modalConfirmarSemBuffer: false,
                salvandoBufferAviso: false,
            })
        }).catch((error) => {
            this.setState({ salvandoBufferAviso: false })
            helper.dispatchEvent("showAviso", {
                message: error?.response?.data?.detail || "Não foi possível dispensar o aviso de buffer. Tente novamente.",
            })
        })
    }

    handleChange = (e) => {
        let { campoParametrizado, teste } = this.state
        campoParametrizado[e.target.name] =  e.target.value

        if (e.target.name === 'descricao' && !this.props.match.params.id) {
            let identificador = String(e.target.value).toLowerCase().replace(/\s/g, '_')
            identificador = identificador.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            identificador = identificador.replace(/[^\w\s]/gi, '')
            if (/^[0-9].+$/.test(identificador))
                identificador = identificador.substring(1)

            campoParametrizado['identificador'] = identificador
        }

        teste['status'] = false

        if (campoParametrizado["tipo_dado_saida"] != "booleano") {
            campoParametrizado["icone_off"] = null
        }

        if (e.target.name === 'tipo_dado_saida') {
            teste['erro'] = ''
            teste['resultado'] = '0'
            teste['invalido'] = false

            this.checa_tipo(e.target.value)
        }

        if (e.target.name === 'tipo_dado_saida') {
            this.setState({ cooldown: true })
        }

        this.setState({ campoParametrizado, teste })
    }

    validation = () => {
        const { campoParametrizado, validacao_campo } = this.state
        let keys = Object.keys(validacao_campo)
        let erro = false

        keys.forEach(key => {
            if (!campoParametrizado[key] && key !== "prioridade" && key !== "formula") {
                validacao_campo[key] = false
                erro = true
            } else {
                validacao_campo[key] = true
            }
        })

        this.setState({ validacao_campo })

        return erro
    }

    saveAction() {
        const { campoParametrizado, referencias, formula_template, parametros_in_formula, isVirtual } = this.state

        let verb, url

        if (this.validation()) return

        this.setState({ cooldown: true })

        if (this.props.match.params.id) {
            verb = this.props.match.params.id ? "PATCH" : "POST"
            url = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/campo-customizado/${this.props.match.params.id}/`
        } else {
            verb = "POST"
            url = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/campo-customizado/`
        }

        let icone = {
            icone_on: campoParametrizado.icone_on,
            icone_off: campoParametrizado.icone_off
        }

        let bodyFormData = new FormData()
        const configuracao = {
            referencias: referencias,
            formula_template: formula_template,
            parametros_in_formula: parametros_in_formula
        }

        bodyFormData.append('equipamento', this.props.match.params.imei)
        bodyFormData.append('descricao', campoParametrizado.descricao)
        bodyFormData.append('identificacao', campoParametrizado.identificador)
        bodyFormData.append('unidade', campoParametrizado.unidade)
        bodyFormData.append('mascara', campoParametrizado.mascara)
        bodyFormData.append('decimal', campoParametrizado.decimal)
        bodyFormData.append('operador_especial', campoParametrizado.operador_especial)
        bodyFormData.append('prioridade', campoParametrizado.prioridade)
        bodyFormData.append('icone', JSON.stringify(icone))
        bodyFormData.append('tipo_dado_saida', campoParametrizado.tipo_dado_saida)
        bodyFormData.append('tipo_grafico', campoParametrizado.tipo_grafico)
        bodyFormData.append('configuracao', JSON.stringify(configuracao))

        if (isVirtual) {
            if (campoParametrizado.tipo_dado_saida === "string") {
                bodyFormData.append('formula', ` "[${campoParametrizado.identificador}]" `)
            } else {
                bodyFormData.append('formula', `[${campoParametrizado.identificador}]`)
            }
        } else {
            bodyFormData.append('formula', campoParametrizado.formula)
        }

        axios({
            method: verb,
            url: url,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (verb === "POST") {
                helper.dispatchEvent("showAviso", {
                    message: `Parâmetro criado com sucesso`,
                    callback: this.props.history.goBack,
                    callbackClose: this.clearForm,
                    callbackLabelClose: "Cadastrar um novo",
                    callbackLabel: "Continuar"
                })
            } else {
                helper.dispatchEvent("showAviso", {
                    message: `Parâmetro editado com sucesso`,
                    callback: this.props.history.goBack,
                })
            }

            this.setState({ cooldown: false })
        }).catch(error => {
            if (error.response.status === 400) {
                let errors = error.response.data

                if (typeof errors === 'object') {
                    if ('acesso' in errors) {
                        helper.dispatchEvent("showAviso", { message: errors['acesso'] })
                    }

                    if ('equipamento' in errors) {
                        helper.dispatchEvent("showAviso", { message: errors['equipamento'] })
                    }

                    if ('identificacao' in errors) {
                        helper.dispatchEvent("showAviso", { message: errors['identificacao'] })
                    }
                }
            }

            this.setState({ cooldown: false })
        })
    }

    handleFormulaFocus = () => {
        let { formulaOnFocus } = this.state
        this.setState({ formulaOnFocus: !formulaOnFocus })
    }

    handleChangeFormula = (value) => {
        let { formula_template } = this.state
        formula_template = value.trim()

        document.getElementById("validacao-formula").innerHTML = ""

        this.setState({ formula_template, cooldown: true })
    }

    converterCampo = (variavel) => {
        let campo = ""

        if (String(variavel) == "") return

        variavel.reverse().forEach((str, index) => {
            index != 0 ? campo += `.${str}` : campo += `${str}`
        })

        this.formulaRef.current?.inserirNoCursor(`[${campo}]`)

        // this.adicionarNaFormula(`[${campo}]`)
    }

    adicionarNaFormula = (variavel) => {
        let { formula_template } = this.state

        if (formula_template?.length == 0) {
            formula_template = `${variavel}`
        } else {
            formula_template += ` ${variavel}`
        }

        document.getElementById("validacao-formula").innerHTML = ""

        this.setState({ formula_template, cooldown: true })
    }

    adicionarFormulaTemplate = (formula) => {
        this.setState({ formula_template: formula })
    }

    testarFormula = async () => {
        let { campoParametrizado, teste, parametros, formula_template } = this.state

        this.setState({ cooldown: true })

        if(!formula_template) {
            document.getElementById("validacao-formula").innerHTML = "Esse campo não pode ser nulo!"
            return
        }

        // verifica se um parâmetro já cadastrado existe na fórmula caso exista irá substituir sua identificação pela sua fórmula.
        let formula = formula_template
        let parametros_in_formula = []

        Array.from(formula.matchAll(/\{(.*?)\}/g)).forEach((item) => {
            const identificacao = item[1]
            const parametro = parametros.find((parametro) => parametro.identificacao === identificacao)

            if(parametro) {
                formula = formula.replaceAll(item[0], parametro.formula)

                if(!parametros_in_formula.includes(parametro.id)) {
                    parametros_in_formula.push(parametro.id)
                }
            } else {
                formula = formula.replaceAll(item[0], 0)
            }

        })

        try {
            this.setState({ loading: true, teste: { resultado: '0', invalido: false, erro: '', status: false } })

            let formula_regex = this.regex(formula)
            let erro = false
            let resultado = "0"

            await this.requestTesteFormula(formula_regex).then((response) => {
                let sucesso = response.data.message

                if (sucesso) {
                    resultado = response.data.result
                    erro = this.validation_saida(resultado)
                } else {
                    erro = true
                }
            }).catch(() => {
                erro = true
            })

            if (erro) {
                teste['invalido'] = true
                teste['erro'] = 'Operação Inválida!'

                campoParametrizado.formula = ""
                parametros_in_formula = []
            } else {
                teste['resultado'] = resultado
                teste['invalido'] = false
                teste['status'] = true

                campoParametrizado.formula = formula
            }

            /*=
                console.log("template formula ->> " + formula_template)
                console.log("formula ->> " + campoParametrizado.formula)
                console.log("parametros na formula ->> " + parametros_in_formula)
            */

            this.setState({ teste, loading: false, cooldown: erro, campoParametrizado, parametros_in_formula })

        } catch (err) {
            teste['invalido'] = true
            teste['erro'] = 'Operação Inválida!'
            this.setState({ cooldown: true, teste })
        }
    }

    requestTesteFormula = (formula) => {
        const data = {
            formula: formula
        }

        return axios({
            method: 'POST',
            url: "https://az3ku1ksma.execute-api.us-east-1.amazonaws.com/formulas_check",
            headers: { 'Content-Type': 'application/json' },
            data: JSON.stringify(data)
        })
    }

    regex = (formula) => {
        try {
            let string_formula = formula

            Array.from(formula.matchAll(/\[(.*?)\]/g)).forEach(v => {
                let campo = { ... this.state.data }

                v[1].split('.').forEach((item) => campo = campo[item] ? campo[item] : 0)

                string_formula = string_formula.replace(v[0], campo)
            })

            return string_formula
        } catch (err) {
            console.error(err)
        }
    }

    validation_saida = (result) => {
        let error = false

        switch (this.state.campoParametrizado.tipo_dado_saida) {
            case "decimal":
                isNaN(result) ? error = true : false

                break
            case "inteiro":
                isNaN(result) ? error = true : false

                break
            case "booleano":

                if (result === "1" || result === "True") {
                    result = true
                } else if (result === "0" || result === "False") {
                    result = false
                }

                !isBoolean(result) ? error = true : false

                break
            default:
                break
        }

        return error
    }

    mostrar_saida = () => {
        let saida = null

        switch (this.state.campoParametrizado.tipo_dado_saida) {
            case "decimal":
                saida = <span className='operacao-valida'>Resultado: <b>{parseFloat(this.state.teste.resultado).toFixed(parseInt(this.state.campoParametrizado.decimal))} {this.state.campoParametrizado.unidade}</b></span>
                break
            case "inteiro":
                saida = <span className='operacao-valida'>Resultado: <b>{parseInt(this.state.teste.resultado)} {this.state.campoParametrizado.unidade}</b></span>
                break
            case "booleano":
                let resultado_booleano = this.state.teste.resultado

                if (resultado_booleano === "1" || resultado_booleano === "True") {
                    resultado_booleano = true
                } else if (resultado_booleano === "0" || resultado_booleano === "False") {
                    resultado_booleano = false
                }

                saida = <span className='operacao-valida'>Resultado: <b>{String(resultado_booleano)} {this.state.campoParametrizado.unidade}</b></span>
                break
            default:
                saida = <span className='operacao-valida'>Resultado: <b>{this.state.teste.resultado} {this.state.campoParametrizado.unidade}</b></span>
                break
        }

        return saida
    }

    checa_tipo = (value) => {
        let campoParametrizado = this.state.campoParametrizado
        switch (value) {
            case 'inteiro':
                campoParametrizado.decimal = "2"
                break
            case 'booleano':
                campoParametrizado.decimal = "2"
                campoParametrizado.unidade = ""
                break
            case 'string':
                campoParametrizado.decimal = "2"
                campoParametrizado.unidade = ""
                campoParametrizado.tipo_grafico = "linha"
                campoParametrizado.operador_especial = "padrao"
                break
            default:
                campoParametrizado.decimal = "2"
                break
        }

        this.setState({ campoParametrizado })
    }

    toggleIconModal = (e) => {
        this.setState({ iconModal: true, icone_tipo: e.target.id })
    }

    add_icon = (icon) => {
        let campoParametrizado = this.state.campoParametrizado
        campoParametrizado['icone_on'] = icon
        this.setState({ campoParametrizado, iconModal: false })
    }

    add_icon_on = (icon) => {
        let campoParametrizado = this.state.campoParametrizado
        campoParametrizado['icone_on'] = icon
        this.setState({ campoParametrizado, iconModal: false })
    }

    add_icon_off = (icon) => {
        let campoParametrizado = this.state.campoParametrizado
        campoParametrizado['icone_off'] = icon
        this.setState({ campoParametrizado, iconModal: false })
    }

    handleTab = (index) => {
        this.setState({ tab: index })
    }

    toggleModalReferencia = (status) => {
        this.setState({ modalReferencia: status })
    }

    render() {
        const { data, validacao_campo, cooldown, loading, tab, modalReferencia, campoParametrizado, isVirtual, formula_template, parametros, loading_parametros, carregandoDados, formulaOnFocus } = this.state

        const theme = {
            scheme: 'monokai',
            author: 'wimer hazenberg (http://www.monokai.nl)',
            base00: 'white',
            base01: '#212529',
            base02: '#212529',
            base03: '#212529',
            base04: '#212529',
            base05: '#212529',
            base06: '#212529',
            base07: '#212529',
            base08: '#212529',
            base09: '#212529',
            base0A: '#212529',
            base0B: '#212529',
            base0C: '#212529',
            base0D: '#212529',
            base0E: '#212529',
            base0F: '#212529',
        }

        return (
            <>
                <ModalAvisoTimestampBuffer
                    avisoAberto={this.state.modalAvisoBuffer}
                    confirmacaoAberta={this.state.modalConfirmarSemBuffer}
                    salvando={this.state.salvandoBufferAviso}
                    onFechar={() => this.setState({ modalAvisoBuffer: false })}
                    onCadastrarAgora={this.cadastrarTimestampDispositivo}
                    onNaoUtilizarBuffer={() => this.setState({
                        modalAvisoBuffer: false,
                        modalConfirmarSemBuffer: true,
                    })}
                    onCancelarConfirmacao={() => this.setState({
                        modalConfirmarSemBuffer: false,
                        modalAvisoBuffer: true,
                    })}
                    onConfirmarDispensa={this.dispensarAvisoBuffer}
                />
                <div data-tour="parametrizacao-root" data-is-virtual={String(Boolean(isVirtual))}>
                    <div className="hdv-default-header mx-3">
                        <span className="screen-menu-desc" style={{ alignItems: 'center' }}>
                            {this.props.match.params.id ? <h4>Editar Parametrização</h4> : <h4>Parametrizar Campos</h4>}
                            <div className="gray-background">
                                <i className="fa fa-hdd fa-2x"></i>
                            </div>
                            {auth.isMasterOrAdmin() ? (
                            <span
                                data-tour="help-campo-parametrizado"
                                title="Ajuda"
                                onClick={() => tourManager.start('parametrizacao')}
                                style={{ marginLeft: '10px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                            >
                                <i className="las la-question-circle hdv-help-tour-icon"></i>
                            </span>
                            ) : null}
                        </span>
                    </div>
                </div>

                <Tabs className="tabs-style" selectedIndex={tab} onSelect={(i) => this.handleTab(i)}>
                    <TabList>
                        <Tab data-tour="param-tab-parametrizar">Parametrizar</Tab>
                        <Tab data-tour="param-tab-referencias">Referências</Tab>
                    </TabList>
                    <TabPanel>
                        <div className="form-parametrizacao-toggle-container">
                            <div
                                className={`
                                    form-parametrizacao-main-content
                                    ${formulaOnFocus ? 'form-parametrizacao-main-content-expanded' : 'form-parametrizacao-main-content-full'}
                                `}
                            >
                                <div className="col-md-12">
                                    <form className="hdv-form-default">
                                        <div className="row">
                                            <div className="col-md-6" data-tour="param-descricao">
                                                <label className="required" htmlFor="descricao">Descrição do parâmetro</label>
                                                <input
                                                    type="text"
                                                    name="descricao"
                                                    value={campoParametrizado.descricao}
                                                    onChange={(e) => this.handleChange(e)}
                                                />
                                                <span id="validacao-descricao" className={!validacao_campo.descricao ? "" : "hdv-noshow-item"}>Campo não pode ser nulo!</span>
                                            </div>
                                            <div style={{/* display: this.props.match.params.id ? "none" : "block" */ }} className="col-md-6" data-tour="param-identificador">
                                                <label className="required" htmlFor="identificador">Identificador</label>
                                                <input
                                                    type="text"
                                                    name="identificador"
                                                    value={campoParametrizado.identificador}
                                                    readOnly={true}
                                                />
                                                <span id="validacao-identificador" className={!validacao_campo.identificador ? "" : "hdv-noshow-item"}>Campo não pode ser nulo!</span>
                                                {campoParametrizado.invalido ? <span id="validacao-identificador">Identificador inválido!</span> : null}
                                            </div>
                                        </div>
                                        <div className="row">
                                            {
                                                !isVirtual ?
                                                    <div className="col-md-12" data-tour="param-formula">
                                                        <label className="required formula-field" htmlFor="formula_template">Fórmula</label>
                                                        <GenericInputFormula
                                                            value={formula_template}
                                                            ref={this.formulaRef}
                                                            onChange={this.handleChangeFormula}
                                                            isOnFocus={formulaOnFocus}
                                                            handleFocus={this.handleFormulaFocus}
                                                            addFormulaTemplate={this.adicionarFormulaTemplate}
                                                        />
                                                        <span id="validacao-formula"></span>
                                                    </div>
                                                    : null
                                            }
                                            <div className="col-md-6" data-tour="param-tipo-dado">
                                                <label className="required" htmlFor="tipo_dado_saida">Tipo do dado na saída</label>
                                                <select value={campoParametrizado.tipo_dado_saida} onChange={(e) => this.handleChange(e)} name="tipo_dado_saida" id="tipo_dado_saida">
                                                    <option value="decimal">Decimal</option>
                                                    <option value="inteiro">Inteiro</option>
                                                    <option value="booleano">Booleano</option>
                                                    <option value="string">Texto</option>
                                                </select>
                                                <span id="validacao-formula" className={!validacao_campo.tipo_dado_saida ? "" : "hdv-noshow-item"}>Campo não pode ser nulo!</span>
                                            </div>
                                            <div style={{ display: (campoParametrizado.tipo_dado_saida === "string") ? "none" : "block" }} className="col-md-6" data-tour="param-tipo-grafico">
                                                <label className="required" htmlFor="tipo_grafico">Visualização em gráficos</label>
                                                <select value={campoParametrizado.tipo_grafico} onChange={(e) => this.handleChange(e)} name="tipo_grafico" id="tipo_grafico">
                                                    <option value="linha">Gráfico de Linha</option>
                                                    <option value="barra">Gráfico de Barras</option>
                                                </select>
                                                <span id="validacao-formula" className={!validacao_campo.tipo_grafico ? "" : "hdv-noshow-item"}>Campo não pode ser nulo!</span>
                                            </div>
                                            {campoParametrizado.tipo_dado_saida == "string" && <div className="col-md-6" data-tour="param-mascara">
                                                <label className="required" htmlFor="mascara">Máscara</label>
                                                <select value={campoParametrizado.mascara} onChange={(e) => this.handleChange(e)} name="mascara" id="mascara">
                                                    <option value="padrao">Padrão</option>
                                                    <option value="horas">Horas, minutos e segundos</option>
                                                </select>
                                            </div>}
                                        </div>
                                        {campoParametrizado.tipo_dado_saida != "inteiro" &&<div style={{ display: (campoParametrizado.tipo_dado_saida === "booleano" || campoParametrizado.tipo_dado_saida === "string") ? "none" : "flex" }} className="row">
                                            <div className={campoParametrizado.tipo_dado_saida == "inteiro" ? "col-md-12" : "col-md-6"} data-tour="param-unidade">
                                                <label className="required" htmlFor="unidade">Unidade</label>
                                                <input
                                                    type="text"
                                                    name="unidade"
                                                    value={campoParametrizado.unidade}
                                                    onChange={(e) => this.handleChange(e)}
                                                />
                                            </div>

                                            <div style={{ display: (campoParametrizado.tipo_dado_saida === "inteiro") ? "none" : "block" }} className="col-md-6" data-tour="param-decimal">
                                                <label className="required" htmlFor="unidade">Decimal</label>
                                                <input
                                                    type="number"
                                                    name="decimal"
                                                    value={campoParametrizado.decimal}
                                                    onKeyPress={(e) => e.preventDefault()}
                                                    onChange={(e) => this.handleChange(e)}
                                                    max="6"
                                                    min="2"
                                                />
                                                <span id="validacao-formula" className={!validacao_campo.decimal ? "" : "hdv-noshow-item"}>Campo não pode ser nulo!</span>
                                            </div>
                                        </div>}
                                        <div className="row">
                                            {campoParametrizado.tipo_dado_saida == "inteiro" && <div className='col-md-4' data-tour="param-unidade">
                                                <label className="required" htmlFor="unidade">Unidade</label>
                                                <input
                                                    type="text"
                                                    name="unidade"
                                                    value={campoParametrizado.unidade}
                                                    onChange={(e) => this.handleChange(e)}
                                                />
                                            </div>}
                                            <div style={{ display: (campoParametrizado?.tipo_dado_saida === "string") ? "none" : "block" }} className={campoParametrizado.tipo_dado_saida == "inteiro" ? "col-md-4" : 'col-md-6'} data-tour="param-operador">
                                                <label className="required" htmlFor="operador_especial">Operador especial</label>
                                                <select value={campoParametrizado.operador_especial} onChange={(e) => this.handleChange(e)} name="operador_especial" id="operador_especial">
                                                    <option value="padrao">Padrão</option>
                                                    <option value="soma">Incremental</option>
                                                    <option value="volume_dia">Volume do dia</option>
                                                    <option value="volume_semanal">Volume da semana</option>
                                                    <option value="volume_mes">Volume do mês</option>
                                                    {/* <option value="conversor_ponto_flutuante">Conversor de ponto flutuante IEEE-754</option> */}
                                                </select>
                                                <span id="validacao-formula" className={!validacao_campo.operador_especial ? "" : "hdv-noshow-item"}>Campo não pode ser nulo!</span>
                                            </div>
                                             {campoParametrizado.tipo_dado_saida != "string" && <div className={campoParametrizado.tipo_dado_saida == "inteiro" ? "col-md-4" : 'col-md-6'} data-tour="param-mascara">
                                                <label className="required" htmlFor="mascara">Máscara</label>
                                                <select value={campoParametrizado.mascara} onChange={(e) => this.handleChange(e)} name="mascara" id="mascara">
                                                    <option value="padrao">Padrão</option>
                                                    <option value="horas">Horas, minutos e segundos</option>
                                                </select>
                                            </div>}
                                        </div>

                                        <div style={{ display: (campoParametrizado.tipo_dado_saida !== "booleano") ? "block" : "none" }} className="row" data-tour="param-icone">
                                            <div className="col-md-12">
                                                <label className="required">Icone</label>
                                                <div id='icone' onClick={this.toggleIconModal} className="escolha-icones">
                                                    <i id='icone' className={"fa " + ((campoParametrizado.icone_on) ? campoParametrizado.icone_on : "fa-hdd") + " fa-4x"}></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ display: (campoParametrizado.tipo_dado_saida === "booleano") ? "flex" : "none" }} className="align-items-center" data-tour="param-icone-booleano">
                                            <div className="mr-4">
                                                <label className="required">Icone (Verdadeiro)</label>
                                                <div onClick={this.toggleIconModal} id="iconeOn" className="escolha-icones">
                                                    <i id="iconeOn" className={"fa " + ((campoParametrizado.icone_on) ? campoParametrizado.icone_on : "fa-hdd") + " fa-4x"}></i>
                                                </div>
                                            </div>
                                            <div>
                                                <label className="required">Icone (Falso)</label>
                                                <div onClick={this.toggleIconModal} id="iconeOff" className="escolha-icones">
                                                    <i id="iconeOff" className={"fa " + ((campoParametrizado.icone_off) ? campoParametrizado.icone_off : "fa-hdd") + " fa-4x"}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <ModalIcone open={this.state.iconModal} toggle={() => this.setState({ iconModal: !this.state.iconModal })}>
                                        {helper.getIconList().map((icon, key) => {
                                            return (
                                                <li key={key}>
                                                    <i className={"fa fa-" + icon} onClick={() =>
                                                        this.state.icone_tipo == "icone" ?
                                                            this.add_icon("fa-" + icon)
                                                            : this.state.icone_tipo == "iconeOn" ?
                                                                this.add_icon_on("fa-" + icon)
                                                                : this.add_icon_off("fa-" + icon)
                                                    }
                                                    ></i>
                                                </li>
                                            )
                                        })
                                        }
                                    </ModalIcone>
                                    {
                                        !isVirtual ?
                                            <div style={{ display: 'flex', margin: '25px 0', alignItems: 'center' }}>
                                                <button onClick={this.testarFormula} className="hdv-btn-forms hdv-btn-blue" data-tour="param-testar-formula">
                                                    Testar fórmula
                                                </button>
                                                {
                                                    loading ?
                                                        <div style={{ marginLeft: "50px" }}><ReactLoading className="hdv-report-loading" type="cylon" color="var(--background-menu)" width={50} /></div>
                                                        :
                                                        this.state.teste.invalido ? <span className="operacao-invalida">{this.state.teste.erro}</span> : this.mostrar_saida()
                                                }
                                            </div>
                                            : <div style={{ marginBottom: "20px" }}></div>
                                    }
                                    <div style={{ marginTop: "0px" }} className="hdv-btn-group">
                                        {(this.props.match.params.id) ? "" : <button onClick={() => this.saveAction(false)} disabled={isVirtual ? false : cooldown} className="hdv-btn-forms hdv-btn-green" data-tour="param-salvar">Salvar e cadastrar um novo</button>}
                                        {(this.props.match.params.id) ? <button onClick={() => this.saveAction(false)} disabled={isVirtual ? false : cooldown} className="hdv-btn-forms hdv-btn-green" data-tour="param-salvar">Salvar</button> : ""}
                                        <button onClick={this.props.history.goBack} className="hdv-btn-forms hdv-btn-yellow">Cancelar</button>
                                    </div>
                                </div>

                            </div>
                            {
                                !isVirtual ?
                                    <div
                                        id="container-campo-customizado"
                                        className={`
                                            campo-customizado
                                            ${formulaOnFocus ? 'campo-customizado-visible' : 'campo-customizado-hidden'}
                                        `}
                                    >
                                        <div className='w-100'>
                                            <details className='custom-summary' open={true}>
                                                <summary>Parâmetros com base no último evento</summary>

                                                <div style={{  maxHeight: '300px', overflow: 'auto' }}>
                                                    {
                                                        carregandoDados
                                                            ?
                                                            <div style={{ paddingTop: "25px", display: "flex", justifyContent: "center" }}>
                                                                <ReactLoading type="spin" color="var(--background-menu)" width={50} />
                                                            </div>
                                                            :
                                                            data === null
                                                                ?
                                                                <span style={{ display: "block", width: "100%", textAlign: "center", padding: "10px" }}>Equipamento não possui eventos registrados</span>
                                                                :
                                                                <JSONTree
                                                                    data={data}
                                                                    labelRenderer={([key]) => <span>{key}: </span>}
                                                                    hideRoot={true}
                                                                    theme={theme}
                                                                    valueRenderer={(valueAsString, value, ...keyPath) => (
                                                                        <button
                                                                            onClick={() => this.converterCampo(keyPath)}
                                                                            style={{ backgroundColor: "#44bb52", color: "white", borderRadius: "5px" }}>
                                                                            {valueAsString}
                                                                        </button>
                                                                    )}
                                                                />
                                                    }
                                                </div>
                                            </details>
                                        </div>

                                        <div className='w-100 mt-3'>
                                            <details className='custom-summary' open={true}>
                                                <summary>Parâmetros cadastrados</summary>

                                                {
                                                    loading_parametros ?
                                                        <div style={{ paddingTop: "25px", display: "flex", justifyContent: "center" }}>
                                                            <ReactLoading type="spin" color="var(--background-menu)" width={50} />
                                                        </div>
                                                        :
                                                        <div className="parametros-cadastrados">
                                                            {
                                                                parametros.length > 0 ?
                                                                    parametros.map((parametro, index) => (
                                                                        <div style={{ display: "flex", flexDirection: "column" }} key={index}>
                                                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", whiteSpace: "nowrap",padding: "5px 0"}}>
                                                                                <span style={{fontWeight: "600",cursor: "pointer", }}>
                                                                                    {parametro.descricao}
                                                                                </span>
                                                                                <span
                                                                                    className="json-tree-param-btn"
                                                                                    onClick={() =>
                                                                                        this.formulaRef.current?.inserirNoCursor(
                                                                                            `{${parametro.identificacao}}`
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {parametro.descricao.toLowerCase().replace(/\s/g, '_')}
                                                                                </span>
                                                                            </div>
                                                                            <span style={{ fontSize: "12px", whiteSpace:"nowrap" }}>{parametro.formula_template}</span>
                                                                        </div>
                                                                    ))
                                                                    : <span style={{ display: "block", width: "100%", textAlign: "center", padding: "10px" }}>Não há parâmetros disponíveis!</span>
                                                            }
                                                        </div>
                                                }
                                            </details>
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <button onClick={() => this.setState({ modalReferencia: true })} className="hdv-btn-forms hdv-btn-blue" data-tour="param-nova-referencia">Nova referência</button>
                        <ReferenciaParametrizacao
                            modalReferencia={modalReferencia}
                            toggleModal={this.toggleModalReferencia}
                            referencias={this.state.referencias}
                            setReferecias={(referencias) => this.setState({ referencias })}
                        />
                    </TabPanel>
                </Tabs>
            </>
        )
    }
}